"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 69: Sunsoft FME-7
 *
 * Ce que fait la puce:
 *   - 8 fenetres CHR de 1 KB a $0000, $0400 ... $1C00, chacune choisie par un
 *     registre distinct. C'est la granularite 1 KB, pas les 8 KB d'un GNROM.
 *   - 4 fenetres PRG de 8 KB a $8000, $A000, $C000 et $E000, la derniere fixee
 *     au dernier banc, plus une fenetre 8 KB a $6000.
 *   - l'agencement des tables de noms, y compris les deux modes mono-ecran.
 *   - un compteur d'IRQ de 16 bits en cycles CPU, avec acquittement par ecriture.
 *
 * La configuration se fait en deux temps, comme sur la puce: on ecrit d'abord le
 * numero de commande -- la valeur fournie, pas l'adresse (https://www.nesdev.org/
 * wiki/Sunsoft_FME-7 : le registre de commande est ".... CCCC") -- dans le registre
 * de commande ($8000-$9FFF), puis le parametre dans le registre de parametre
 * ($A000-$BFFF). C'est l'ecriture du parametre qui declenche la commande. Seuls
 * A14/A15 (et pas A12/A13) decodent les deux registres, donc n'importe quelle
 * adresse dans $8000-$9FFF est le registre de commande et n'importe quelle adresse
 * dans $A000-$BFFF est le registre de parametre; $C000-$FFFF n'est pas decode sur
 * la FME-7 (la 5B y place ses registres audio).
 *
 * Ne pas confondre avec le GNROM, qui porte le meme numero iNES: le GNROM a deux
 * fenetres CHR de 8 KB et un unique registre de 4 bits. Batman est une FME-7, et
 * sous un GNROM ses sprites et ses fonds venaient de n'importe ou.
 * ------------------------------------------------------------------ */
// Sunsoft FME-7 (Batman: Return of the Joker)

// Fenetres CHR de 1 KB, dans l'ordre ou le jeu les adresse.
var CHR_WINDOWS = [
  0x0000, 0x0400, 0x0800, 0x0c00, 0x1000, 0x1400, 0x1800, 0x1c00,
];

// Commandes.
var CMD_CHR0 = 0x0; // $0-7 : banc CHR 1 KB, l'un des sept autres par +1
var CMD_PRG0 = 0x8; // $8   : banc a $6000
var CMD_PRG1 = 0x9; // $9   : banc a $8000
var CMD_PRG2 = 0xa; // $A   : banc a $A000
var CMD_PRG3 = 0xb; // $B   : banc a $C000
var CMD_NAMETABLE = 0xc; // $C   : agencement des tables de noms
var CMD_IRQ_CONTROL = 0xd; // $D   : controle du compteur d'IRQ
var CMD_IRQ_LOW = 0xe; // $E   : octet bas du compteur d'IRQ
var CMD_IRQ_HIGH = 0xf; // $F   : octet haut du compteur d'IRQ

function register(Mappers) {
  Mappers[69] = function (nes) {
    this.nes = nes;
    // Miroir : l'agencement des tables de noms controle par le registre $C.
    // 0=H, 1=V, 2=1scA, 3=1scB. Persiste au reset.
    this.mirroring = 0;
  };

  Mappers[69].prototype = new Mappers[0]();

  // La FME-7 compte des cycles CPU, pas des balayages : c'est ce qui permet a un
  // jeu de viser un point precis de la ligne sans avoir a deviner en lignes
  // entieres. NES.frame() lui fournit donc le compte exact.
  Mappers[69].prototype.watchesCpuCycles = true;

  // La puce pilote elle-meme ses tables de noms, donc NES.reset() ne doit pas lui
  // imposer l'agencement de l'en-tete iNES par-dessus son propre registre.
  Mappers[69].prototype.ownsMirroring = true;

  Mappers[69].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);

    // Registres de banking. Les huit fenetres CHR partent a 0, les trois fenetres
    // PRG commutable aussi, et la fenetre $6000 sur le banc 0.
    this.chrBanks = [0, 0, 0, 0, 0, 0, 0, 0];
    this.prgBanks = [0, 0, 0]; // $8000, $A000, $C000
    this.prgBank6000 = 0;

    // $6000-$7FFF : 8 Ko de PRG-RAM (save RAM) sur la cartouche, separee de la
    // RAM de travail du 2A03 ($0000-$1FFF). Activee par bit 7, selectionnee par
    // bit 6 du registre $8. En mode ROM, un banc commutable y est mappe.
    this.prgRamEnabled = false;
    this.prgRamSelected = false;
    this.prgRam = new Uint8Array(8192); // 8 Ko de save RAM

    // Commande en attente dans le registre de commande.
    this.command = 0;

    // Miroir : l'agencement des tables de noms controle par le registre $C.
    // 0=H, 1=V, 2=1scA, 3=1scB. Persiste au reset.
    this.mirroring = 0;

    // IRQ. Compteur 16 bits decremente de un par cycle CPU, passage de $0000 a
    // $FFFF qui declenche l'IRQ, ligne maintenue basse jusqu'a l'acquittement.
    this.irqCounter = 0;
    this.irqCounterEnabled = false;
    this.irqEnabled = false;
    // L'IRQ reste assertee sur le fil jusqu'a ce que le jeu l'acquitte. Sans ce
    // drapeau, le CPU verrait l'IRQ disparaitre et le compteur repartir de zero
    // comme si de rien n'etait.
    this.irqAsserted = false;
  };

  Mappers[69].prototype.write = function (address, value) {
    if (address < 0x6000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    if (address < 0x8000) {
      // $6000-$7FFF. En mode WRAM (registre $8, bits 7 et 6 poses), les
      // ecritures vont dans la PRG-RAM de la cartouche, pas dans la ROM. Les
      // lectures (mmap.load) viennent directement de cpu.mem, sans passer par le
      // mapper : il faut donc les y repercuter, sinon le jeu relit de vieilles
      // valeurs. Batman: Return of the Joker ecrit ses tables de scratch a
      // $7DB0-$7EFF a chaque frame puis les relit pour composer ses tuiles : sans
      // ce miroir, tout restait a zero et l'ecran restait noir apres la remise a
      // zero initiale. En mode ROM, ecrire sur la fenetre ROM ne fait rien sur la
      // vraie puce, on l'ignore donc.
      if (this.prgRamEnabled && this.prgRamSelected) {
        this.nes.cpu.mem[address] = value;
        this.prgRam[address - 0x6000] = value;
        if (this.nes.rom.batteryRamData) {
          this.nes.rom.batteryRamData[address - 0x6000] = value;
        }
        if (typeof this.nes.opts.onBatteryRamWrite === "function") {
          this.nes.opts.onBatteryRamWrite(address, value);
        }
      }
      return;
    }

    if (address >= 0x8000 && address <= 0x9fff) {
      // Registre de commande : le numero de commande EST la valeur ecrite
      // (le champ ".... CCCC"), pas l'adresse. Rien n'est fait ici, l'ecriture
      // du parametre invoque la commande.
      this.command = value & 0x0f;
      return;
    }

    if (address >= 0xa000 && address <= 0xbfff) {
      // Registre de parametre : c'est cette ecriture qui invoque la commande.
      this.runCommand(this.command, value);
    }

    // $C000-$FFFF : pas decode sur la FME-7 (la 5B y a ses registres audio).
  };

  Mappers[69].prototype.runCommand = function (command, value) {
    if (command <= CMD_CHR0 + 7 && command >= CMD_CHR0) {
      // $0-7 : un banc CHR de 1 KB dans la fenetre correspondante. La FME-7 a huit
      // lignes d'adresse CHR; le 5A et le 5B n'en ont que sept, ce qui n'a jamais
      // fait differer un jeu release.
      var window = CHR_WINDOWS[command];
      this.chrBanks[command] = value;
      this.load1kVromBank(value & 0xff, window);
      return;
    }

    switch (command) {
      case CMD_PRG0:
        // $8 : fenetre $6000. Bit 7 active la PRG-RAM, bit 6 choisit RAM (1) ou
        // ROM (0). En mode ROM, un banc 8 Ko commutable y est mappe. En mode RAM,
        // c'est la PRG-RAM de 8 Ko de la cartouche (separee de la RAM CPU).
        this.prgRamEnabled = (value & 0x80) !== 0;
        this.prgRamSelected = (value & 0x40) !== 0;
        this.prgBank6000 = value & 0x3f;

        if (!this.prgRamEnabled) {
          // PRG-RAM desactivee : la fenetre $6000-$7FFF renvoie open bus (0).
          // On ne fait rien, le CPU lira 0.
          return;
        }
        if (this.prgRamSelected) {
          // Mode RAM : mapper la PRG-RAM de la cartouche a $6000.
          // On installe un handler de lecture/ecriture via le CPU mem.
          // Pour simplifier, on copie la PRG-RAM dans l'espace CPU a chaque changement
          // de mode, et on intercepte les ecritures via un proxy... mais le CPU
          // n'a pas de hook. Solution simple : on ne mappe pas en lecture directe,
          // le jeu lit/ecrit via $6000-$7FFF qui est deja dans cpu.mem.
          // On s'assure juste que cpu.mem[0x6000..0x7FFF] pointe vers this.prgRam.
          // Le plus simple : a chaque ecriture du jeu dans cette zone, on la reporte
          // dans this.prgRam, et a chaque lecture on sert depuis this.prgRam.
          // Mais le CPU ne passe pas par le mapper pour $6000. Donc on doit
          // synchroniser manuellement. Ici on se contente de copier this.prgRam
          // dans cpu.mem a chaque changement de mode RAM.
          var cpuMem = this.nes.cpu.mem;
          for (var i = 0; i < 8192; i++) {
            cpuMem[0x6000 + i] = this.prgRam[i];
          }
          return;
        }
        // Mode ROM : charger le banc PRG selectionne.
        this.load8kRomBank(this.prgBank6000, 0x6000);
        return;

      case CMD_PRG1:
        this.prgBanks[0] = value & 0x3f;
        this.load8kRomBank(this.prgBanks[0], 0x8000);
        return;

      case CMD_PRG2:
        this.prgBanks[1] = value & 0x3f;
        this.load8kRomBank(this.prgBanks[1], 0xa000);
        return;

      case CMD_PRG3:
        this.prgBanks[2] = value & 0x3f;
        this.load8kRomBank(this.prgBanks[2], 0xc000);
        return;

      case CMD_NAMETABLE:
        // $C : bits 1-0. Les deux modes mono-ecran comptent aussi, et des jeux
        // s'en servent : sans eux la moitie basse de l'ecran se recopie dans la
        // moitie haute.
        this.mirroring = value & 0x03;
        switch (this.mirroring) {
          case 0:
            this.setMirroring(this.nes.rom.HORIZONTAL_MIRRORING);
            break;
          case 1:
            this.setMirroring(this.nes.rom.VERTICAL_MIRRORING);
            break;
          case 2:
            this.setMirroring(this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN);
            break;
          default:
            this.setMirroring(this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN_ALT);
            break;
        }
        return;

      case CMD_IRQ_CONTROL:
        // $D : bit 7 fait tourner le compteur, bit 0 autorise l'IRQ. Toute
        // ecriture acquitte l'IRQ en cours, que les deux bits soient mis ou non.
        this.irqCounterEnabled = (value & 0x80) !== 0;
        this.irqEnabled = (value & 0x01) !== 0;
        this.irqAsserted = false;
        return;

      case CMD_IRQ_LOW:
        // $E et $F : ecriture directe dans le compteur. Il n'y a pas de latch de
        // rechargement comme sur le MMC3 : le jeu compte a rebours depuis la
        // valeur qu'il vient d'ecrire.
        this.irqCounter = (this.irqCounter & 0xff00) | value;
        return;

      case CMD_IRQ_HIGH:
        this.irqCounter = (this.irqCounter & 0x00ff) | (value << 8);
        return;
    }

    // Commande inconnue : la FME-7 l'ignore, comme un jeu qui sonde $8000-$FFFF.
  };

  Mappers[69].prototype.clockCpuCycles = function (cycles) {
    if (!this.irqCounterEnabled || this.irqAsserted) {
      return;
    }

    var counter = this.irqCounter;
    for (var i = 0; i < cycles; i++) {
      // Le passage de $0000 a $FFFF est ce qui declenche l'IRQ, pas l'arrivee a
      // zero. C'est pour ca qu'un jeu ecrit "cycles voulues moins un".
      counter = counter === 0 ? 0xffff : counter - 1;
      if (counter === 0xffff) {
        if (this.irqEnabled) {
          this.nes.cpu.requestIrq(this.nes.cpu.IRQ_NORMAL);
          this.irqAsserted = true;
        }
        return;
      }
    }

    this.irqCounter = counter;
  };

  Mappers[69].prototype.loadBatteryRam = function () {
    // Comme le Mappers[0], charge la sauvegarde dans l'espace CPU, mais aussi
    // dans la copie propre au mapper : le premier passage en mode WRAM (commande
    // $8) recopie this.prgRam dans cpu.mem, ce qui ecraserait la sauvegarde.
    var ram = this.nes.rom.batteryRamData;
    if (ram !== null && ram !== undefined && ram.length > 0) {
      for (var i = 0; i < 8192 && i < ram.length; i++) {
        this.prgRam[i] = ram[i];
        this.nes.cpu.mem[0x6000 + i] = ram[i];
      }
    }
  };

  Mappers[69].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("FME-7: Invalid ROM! Unable to load.");
    }

    // Le registre de miroir ($C) persiste au reset : le sauvegarder avant reset().
    var savedMirroring = this.mirroring;

    this.reset();
    // Restorer le miroir apres reset (qui le remet a 0).
    this.mirroring = savedMirroring;

    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();

    // $E000 est fixe au dernier banc : c'est la que vit le vecteur de reset, donc
    // le CPU doit pouvoir y demarrer sans que le jeu ait ecrit quoi que ce soit.
    // Les trois autres fenetres commencent sur les trois premiers bancs, comme sur
    // une puce qui sort de veille.
    this.load8kRomBank(this.nes.rom.romCount * 2 - 1, 0xe000);
    this.load8kRomBank(this.prgBanks[0], 0x8000);
    this.load8kRomBank(this.prgBanks[1], 0xa000);
    this.load8kRomBank(this.prgBanks[2], 0xc000);

    for (var i = 0; i < 8; i++) {
      this.load1kVromBank(this.chrBanks[i], CHR_WINDOWS[i]);
    }

    // Appliquer le miroir sauvegarde (le registre $C persiste au reset).
    // ownsMirroring empeche NES.loadROM de le remplacer par l'en-tete.
    switch (this.mirroring) {
      case 0:
        this.setMirroring(this.nes.rom.HORIZONTAL_MIRRORING);
        break;
      case 1:
        this.setMirroring(this.nes.rom.VERTICAL_MIRRORING);
        break;
      case 2:
        this.setMirroring(this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN);
        break;
      default:
        this.setMirroring(this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN_ALT);
        break;
    }

    // Par defaut la PRG-RAM est desactivee (comme au power-on).
    // Le jeu l'active via le registre $8 bit 7.
    this.prgRamEnabled = false;
    this.prgRamSelected = false;
    // Ne pas copier la PRG-RAM dans cpu.mem tant qu'elle n'est pas activee.

    this.resetIrqHandler();
  };

  Mappers[69].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.chrBanks = this.chrBanks.slice();
    s.prgBanks = this.prgBanks.slice();
    s.prgBank6000 = this.prgBank6000;
    s.prgRamEnabled = this.prgRamEnabled;
    s.prgRamSelected = this.prgRamSelected;
    s.prgRam = Array.from(this.prgRam); // Uint8Array -> array pour JSON
    s.mirroring = this.mirroring;
    s.command = this.command;
    s.irqCounter = this.irqCounter;
    s.irqCounterEnabled = this.irqCounterEnabled;
    s.irqEnabled = this.irqEnabled;
    s.irqAsserted = this.irqAsserted;
    return s;
  };

  Mappers[69].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.chrBanks = s.chrBanks.slice();
    this.prgBanks = s.prgBanks.slice();
    this.prgBank6000 = s.prgBank6000;
    this.prgRamEnabled = s.prgRamEnabled;
    this.prgRamSelected = s.prgRamSelected;
    this.prgRam = new Uint8Array(s.prgRam || 8192);
    this.mirroring = s.mirroring || 0;
    this.command = s.command;
    this.irqCounter = s.irqCounter;
    this.irqCounterEnabled = s.irqCounterEnabled;
    this.irqEnabled = s.irqEnabled;
    this.irqAsserted = s.irqAsserted;
    // Reappliquer la PRG-RAM a la memoire CPU si selectionnee.
    if (this.prgRamEnabled && this.prgRamSelected) {
      var cpuMem = this.nes.cpu.mem;
      for (var i = 0; i < 8192; i++) {
        cpuMem[0x6000 + i] = this.prgRam[i];
      }
    }
    // Reappliquer le miroir.
    switch (this.mirroring) {
      case 0:
        this.setMirroring(this.nes.rom.HORIZONTAL_MIRRORING);
        break;
      case 1:
        this.setMirroring(this.nes.rom.VERTICAL_MIRRORING);
        break;
      case 2:
        this.setMirroring(this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN);
        break;
      default:
        this.setMirroring(this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN_ALT);
        break;
    }
  };
}

module.exports = { register: register };
